import React from 'react';
import { TabsProvider } from '../../context/TabsContext';
import { UndoRedoProvider } from '../../context/UndoRedoContext';
import { useAppContent } from './hooks/useAppContent';
import { AppShell } from './components/AppShell';
import '../../App.css';

/**
 * Plet - Visual Project Management
 *
 * Unified view: Templates and Sprints use the same detail view.
 * Templates are just "master copies" that you create instances from.
 */
function AppContent() {
  const appProps = useAppContent();
  return <AppShell {...appProps} />;
}

/**
 * App wrapper that provides TabsContext and UndoRedoContext
 */
function App() {
  return (
    <TabsProvider>
      <UndoRedoProvider>
        <AppContent />
      </UndoRedoProvider>
    </TabsProvider>
  );
}

export default App;
